import React, { ChangeEvent, RefObject } from 'react';
import { Button, Form, Input, InputNumber, Radio, Flex, InputRef, Checkbox } from 'antd';
import EditorCard from '../content/editorCard'; // Adjust path as needed
import { useAuth } from '../../auth/authcontext';
import DeleteOptionGroup from './deleteoptiongroup';

interface MenuOptionPropertyEditorProps {
    selectedMogGuid: string;
    selectedMogName: string;
    selectedMogDisplayName: string;
    selectedMogMinSelect: number;
    selectedMogMaxSelect: number;
    selectedMogModifier: string;
    modifierOptions: { label: string; value: string }[];
    isWarnGroupName: boolean;
    isWarnGroupDisplayName: boolean;
    inputRefGroupName: RefObject<InputRef>;
    handleMogNameChange: (e: ChangeEvent<HTMLInputElement>) => void;
    handleMogDisplayNameChange: (e: ChangeEvent<HTMLInputElement>) => void;
    handleChangeMinSelect: (value: number | null) => void;
    handleChangeMaxSelect: (value: number | null) => void;
    handleChangeModifier: (value: string) => void;
    handleSaveMenuOptionGroup: () => void;
    handleDeleteMenuOptionGroup: () => void;
    formLabelstyle?: React.CSSProperties;
    selectedMogIsOnSale: boolean;
    handleChangeIsOnSale: (checked: boolean) => void;
}

const MenuOptionPropertyEditor: React.FC<MenuOptionPropertyEditorProps> = ({
    selectedMogGuid,
    selectedMogName,
    selectedMogDisplayName,
    selectedMogMinSelect,
    selectedMogMaxSelect,
    selectedMogModifier,
    modifierOptions,
    isWarnGroupName,
    isWarnGroupDisplayName,
    inputRefGroupName,
    handleMogNameChange,
    handleMogDisplayNameChange,
    handleChangeMinSelect,
    handleChangeMaxSelect,
    handleChangeModifier,
    handleSaveMenuOptionGroup,
    handleDeleteMenuOptionGroup,
    formLabelstyle = { width: '120px', fontWeight: 500 },
    selectedMogIsOnSale,
    handleChangeIsOnSale,
}) => {
    const { isReadOnly } = useAuth();
    return (
        <EditorCard title="Group Properties">
            <Form name="MenuOptionGroupProperties" layout="vertical">
                <Flex gap="middle" vertical>
                    <Flex gap="middle">
                        <label style={formLabelstyle}>Name:</label>
                        <Input
                            value={selectedMogName}
                            placeholder="Group Name"
                            required
                            ref={inputRefGroupName}
                            onChange={handleMogNameChange}
                            style={{
                                borderWidth: '1px',
                                borderStyle: 'solid',
                                borderRadius: '8px 0 0 8px',
                                width: '20%',
                                fontSize: '14px',
                            }}
                        />
                        {isWarnGroupName && (
                            <span style={{ color: 'red' }}>Group Name is Required</span>
                        )}
                    </Flex>

                    <Flex gap="middle">
                        <label style={formLabelstyle}>Kiosk Text:</label>
                        <Input
                            value={selectedMogDisplayName}
                            onChange={handleMogDisplayNameChange}
                            placeholder="Display Name"
                            style={{
                                borderWidth: '1px',
                                borderStyle: 'solid',
                                borderRadius: '8px 0 0 8px',
                                width: '20%',
                                fontSize: '14px',
                            }}
                        />
                        {isWarnGroupDisplayName && (
                            <span style={{ color: 'red' }}>
                                Kiosk Text is Required. What would you like the customer to see above the options shown on the kiosk?
                            </span>
                        )}
                    </Flex>

                    <Flex gap="middle">
                        <label style={formLabelstyle}>Min Selection:</label>
                        <InputNumber
                            value={selectedMogMinSelect}
                            onChange={handleChangeMinSelect}
                            placeholder="0"
                            min={0}
                            max={30}
                            style={{
                                borderWidth: '1px',
                                borderStyle: 'solid',
                                borderRadius: '8px 0 0 8px',
                                width: '5%',
                                fontSize: '14px',
                            }}
                        />
                        <label style={formLabelstyle}>Max Selection</label>
                        <InputNumber
                            value={selectedMogMaxSelect}
                            onChange={handleChangeMaxSelect}
                            placeholder="0"
                            min={0}
                            max={30}
                            style={{
                                borderWidth: '1px',
                                borderStyle: 'solid',
                                borderRadius: '8px 0 0 8px',
                                width: '5%',
                                fontSize: '14px',
                            }}
                        />
                    </Flex>

                    <Flex gap="middle">
                        <label style={formLabelstyle}>Modifier:</label>
                        <Radio.Group
                            options={modifierOptions}
                            defaultValue="None"
                            optionType="button"
                            buttonStyle="solid"
                            value={selectedMogModifier}
                            onChange={(e) => handleChangeModifier(e.target.value)}
                        />
                    </Flex>

                    <Flex gap="middle">
                        <label style={formLabelstyle}>On Sale:</label>
                        <Checkbox
                            checked={selectedMogIsOnSale}
                            onChange={(e) => handleChangeIsOnSale(e.target.checked)}
                        />
                    </Flex>

                    <Flex gap="middle">
                        <label style={formLabelstyle}></label>
                        {!isReadOnly && (
                            <Button
                                color="green"
                                variant="solid"
                                size="small"
                                style={{
                                    marginTop: '20px',
                                    paddingInline: '15px',
                                    fontSize: '12px',
                                    width: '100px',
                                }}
                                onClick={handleSaveMenuOptionGroup}
                            >
                                Save Changes
                            </Button>
                        )}
                        <Flex style={{ marginLeft: 'auto' }}>
                            <DeleteOptionGroup
                                selectedMogGuid={selectedMogGuid}
                                handleDeleteMenuOptionGroup={handleDeleteMenuOptionGroup}
                            />
                        </Flex>
                    </Flex>
                </Flex>
            </Form>
        </EditorCard>
    );
};

export default MenuOptionPropertyEditor;